import React, { useEffect } from 'react';
import styles from './Toast.module.css';

export type ToastType = 'error' | 'success' | 'warning' | 'info';

interface ToastProps {
    message: string;
    type?: ToastType;
    onClose: () => void;
    duration?: number;
}

export const Toast: React.FC<ToastProps> = ({
    message,
    type = 'info',
    onClose,
    duration = 5000
}) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`${styles.toast} ${styles[type]}`} role={type === 'error' ? 'alert' : undefined}>
            {message}
            <button onClick={onClose} className={styles.closeButton} aria-label="Close">×</button>
        </div>
    );
};

export default Toast;
